// npm library imports
import Image from 'next/image';
import { memo } from 'react';

// type imports
import { CarouselImage } from '@lib/types';

// style imports
import style from './imageGallery.module.scss';

/**
 * Renders a single iamge consistently with onClick effects for the image gallery
 * 
 * @param props - component props
 * @param props.image - CarouselImage to be rendered
 * @param props.onClick Optional - onClick event handler for the image
 * 
 * @returns - Single image for gallery with onCLick event
 */
const SingleGalleryImage = memo(
    ({ image, onClick }: { image: CarouselImage; onClick?: () => void }) => (
        <div 
            className={style.imgContainer} 
            onClick={onClick} 
            role="button" 
            tabIndex={0}
            aria-label={`Open image: ${image.alt}`}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onClick?.();
                }
            }}
        >
            <Image
                loading="lazy"
                src={image.path}
                width={image.width}
                height={image.height}
                alt={image.alt}
                placeholder="blur"
                blurDataURL={image.blurDataURL}
                quality={100}
                className={style.img}
            />
        </div>
    ),
);

// Fixing lint Error: Component definition is missing display name react/display-name caused by memo
SingleGalleryImage.displayName = 'SingleGalleryImage';

export default SingleGalleryImage;
